/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1CompetenceId202,
  DeleteApiV1CompetenceId401,
  DeleteApiV1CompetenceId404,
  DeleteApiV1CompetenceId500,
  DeleteApiV1CompetenceIdMutationResponse,
  DeleteApiV1CompetenceIdPathParams,
} from "../../types/competenceRegistroController/DeleteApiV1CompetenceId.ts";

export const deleteApiV1CompetenceIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<DeleteApiV1CompetenceIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const deleteApiV1CompetenceId202Schema =
  z.any() as unknown as ToZod<DeleteApiV1CompetenceId202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1CompetenceId401Schema =
  z.any() as unknown as ToZod<DeleteApiV1CompetenceId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1CompetenceId404Schema =
  z.any() as unknown as ToZod<DeleteApiV1CompetenceId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1CompetenceId500Schema =
  z.any() as unknown as ToZod<DeleteApiV1CompetenceId500>;

export const deleteApiV1CompetenceIdMutationResponseSchema = z.lazy(
  () => deleteApiV1CompetenceId202Schema,
) as unknown as ToZod<DeleteApiV1CompetenceIdMutationResponse>;
